"use client";

import { ArrowRight, PartyPopper } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import styles from "./youtube-kalshi.module.css";

export function PracticeBetCelebration({ open, onClose, onContinue, onRestoreFocus }: {
  open: boolean; onClose: () => void; onContinue: () => void; onRestoreFocus: () => void;
}) {
  return <Dialog open={open} onOpenChange={(value) => { if (!value) onClose(); }}>
    <DialogContent className="max-w-[min(94vw,560px)]" contentClassName={styles.celebration} onCloseAutoFocus={(event) => { event.preventDefault(); onRestoreFocus(); }}>
      <div className={styles.celebrationIcon} aria-hidden="true"><PartyPopper size={34} /></div>
      <DialogTitle className={styles.celebrationTitle}>You made your first +EV practice bet using Upside!</DialogTitle>
      <DialogDescription className={styles.celebrationDescription}>Nice work. You found the edge, used Matt’s weights, and reviewed your Kalshi order. You’ve practiced the whole process.</DialogDescription>
      <button className={styles.primary} onClick={onContinue}>Next: Try Whale Watch <ArrowRight size={18} /></button>
      <button className={styles.textButton} onClick={onClose}>Review my practice bet</button>
      <p className={styles.celebrationNote}>Simulation complete. No real bet or money was involved. +EV describes an estimate, not a guaranteed win.</p>
    </DialogContent>
  </Dialog>;
}
